import React, { useEffect } from "react";
import { RCCAlert, RCCButton, RCCGrid, RCCTooltip } from "react-common-components";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "src/context/Translations/context";
import { v4 } from "uuid";
import FiveWhyItem from "./5WhyItem";
import { IComponentFiveWhy } from "./interface";

const FiveWhy: React.FC<IComponentFiveWhy> = ({
	register,
	addResponseToCause,
	disabled,
	isPresentation,
	watch,
	errors,
	control,
	clearErrors,
	fiveWhyDefaultValue,
	updateFunction
}) => {
	const { translate } = useTranslation();

	const { 
		fields: fields5Why, 
		remove: remove5Why,
		append: append5Why
	} = useFieldArray({
		control,
		name: "intba003"
	});

	const add5WhyFunction = () => {
		clearErrors("intba003");
		const fiveWhy: any = {};
		fiveWhy.ina003Id = "0";
		fiveWhy.ina003Pergunta = "";
		fiveWhy.ina003Resposta = "";

		append5Why(fiveWhy);
		updateFunction();
	};

	const remove5WhyFunction = (index: number) => {			
		remove5Why(index);
	};

	useEffect(() => {
		append5Why(fiveWhyDefaultValue && fiveWhyDefaultValue.length > 0 ? fiveWhyDefaultValue.map((fiveWhy) => ({
			...fiveWhy
		})) : []);
	}, []);

	return(
		<RCCGrid container item direction="column" alignItems="center">
			<RCCGrid
				container
				item
				justifyContent="flex-end"
			>
				{!isPresentation && (
					<RCCTooltip
						text={translate("Novo porquê")}
						color="purple"
						position="left"
					>
						<RCCButton
							icon={{name: "plus", color: "#FFF", size: 18}}
							color="purple"
							layout="isRounded"
							onClick={() => add5WhyFunction()}
							size="md"
							disabled={disabled}
						/>
					</RCCTooltip>
				)}
			
			</RCCGrid>

			{fields5Why.length === 0 ? (
				<RCCAlert
					title={translate("Atenção")}
					description={translate("Não foram encontrados dados")}
				/>
			) : (
				<>
					{fields5Why.map((field5Why: any, index: number) => (
						<FiveWhyItem 
							key={v4()}
							remove5WhyFunction={remove5WhyFunction}
							addResponseToCause={addResponseToCause}
							disabled={disabled}
							isPresentation={isPresentation}
							register={register}
							watch={watch}
							errors={errors}
							updateFunction={updateFunction}
							field5Why={field5Why}
							index={index}
						/>
					))}
				</>
			)}

			
		</RCCGrid>
	);
};

export default FiveWhy;
